
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-delete",
  "use": "icon-material-delete-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-delete\"><path d=\"M259.09-114.02q-28.45 0-48.41-19.89t-19.96-48.24v-565.94h-45.07v-68.13h198.28v-34.3h271.9v34.3h198.52v68.13h-45.07v565.94q0 27.6-20.33 47.86-20.34 20.27-48.04 20.27zm441.82-634.07H259.09v565.94h441.82zM363.89-266.24h64.07v-399h-64.07zm168.15 0h64.31v-399h-64.31zM259.09-748.09v565.94z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-delete"/>
                </svg>
            );
        };

        Icon.id = "icon-material-delete";

        export default Icon;
    